import { render } from "./SafetyDocumentView.vue?vue&type=template&id=0750e91a&scoped=true&ts=true"
import script from "./SafetyDocumentView.vue?vue&type=script&lang=ts"
export * from "./SafetyDocumentView.vue?vue&type=script&lang=ts"

import "./SafetyDocumentView.vue?vue&type=style&index=0&id=0750e91a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0750e91a"]])

export default __exports__